import menuBg from '../assets/menu-bg.png';

export function PlayModeSelect({ onSinglePlayer, onOnline, onBack }: {
  onSinglePlayer: () => void;
  onOnline: () => void;
  onBack: () => void;
}) {
  return (
    <div className="menu playmodemenu" style={{ background: `#0a0c12 url(${menuBg}) center / cover no-repeat` }}>
      <div className="playmodepanel screen-in">
        <h2>Choose How to Play</h2>
        <p>Battle commanders or challenge the battlefield AI.</p>
        <div className="playmodechoices">
          <button onClick={onSinglePlayer}><span className="playmodeicon">♜</span><b>Single Player</b><small>1v1 or 2v2 with configurable AI armies</small></button>
          <button onClick={onOnline}><span className="playmodeicon">⚔</span><b>Online</b><small>Public matchmaking or private friend rooms</small></button>
        </div>
        <button className="linkbtn" onClick={onBack}>← Back to main menu</button>
      </div>
    </div>
  );
}
